<template>
  <div class="dashboard1">
    <div class="card1" v-for="card in cards2" :key="card.id" @click="item(card.id)">
      <div class="card-icon1">
       {{ card.count }}
      </div>
      <div class="card-info">
        <h2>{{ card.title }}</h2>
      </div>
    </div>
  </div>
  <br>
</template>

<script>
import { GChart } from "vue-google-charts";
export default {
  name: "Pengguna",
  components: {
        GChart
  },
  data() {
    return {
      cards: [
        { id: 1, title: 'Jumlah Pengguna', count: 1500, icon: 'fas fa-users' },
        { id: 2, title: 'Pengguna Aktif', count: 1200, icon: 'fas fa-user-check' },
        { id: 3, title: 'Pengguna Baru', count: 300, icon: 'fas fa-user-plus' },
        { id: 4, title: 'Pengguna Baru', count: 300, icon: 'fas fa-user-plus' },
        { id: 5, title: 'Pengguna Baru', count: 300, icon: 'fas fa-user-plus' },
      ],
      cards2:[],
    }
  },
  methods:{
    getData(){
      this.$zcomm.get(this.api_service + 'dashboard/baka_status', {}).then(res => {
        this.cards2 = res
      })
    },
    item(id){
      window.location.href = window.route('baka.index')+'?status='+id;
    },
  },
      
  mounted() {
    this.getData()
  }
}
      

</script>  
<style type="text/css">
  .dashboard1 {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 30px;
  padding: 20px;
  background-color: #f5f5f5;
}

.card1 {
  background: linear-gradient(135deg, #42a5f5, #478ed1);
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 250px;
  text-align: center;
  color: #fff;
  transition: transform 0.3s, box-shadow 0.3s;
}

.card1:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
}

.card-icon1 {
  font-size: 60px;
  margin-right: 95px;
  margin-bottom: 15px;
  color: rgba(255, 255, 255, 0.8);
  transition: color 0.3s;
}

.card1:hover .card-icon1 {
  color: #fff;
}

.card-info h2 {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  color: #f1f1f1;
  letter-spacing: 1px;
}

.card-info p {
  margin-top: 8px;
  font-size: 28px;
  font-weight: bold;
  color: #fff;
}

.card1:nth-child(2) {
  background: linear-gradient(135deg, rgb(71 247 80 / 36%), rgb(50 148 54)), url(/images/p-lulus.png) center / cover no-repeat;
 /* background: linear-gradient(135deg, rgba(66, 165, 245, 0.7), rgba(71, 142, 209, 0.7)),
              url('/images/check.png') center/cover no-repeat;*/
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 250px;
  text-align: center;
  color: #fff;
  transition: transform 0.3s, box-shadow 0.3s;
/*  background: linear-gradient(135deg, #66bb6a, #43a047);*/
}

.card1:nth-child(1) {
  background: linear-gradient(135deg, rgb(254 154 23 / 7%), rgb(254 154 26)), url(/images/p-mohon.png) center / cover no-repeat;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 250px;
  text-align: center;
  color: #fff;
  transition: transform 0.3s, box-shadow 0.3s;
/*  background: linear-gradient(135deg, #ffa726, #fb8c00);*/
}

.card1:nth-child(4) {
  background: linear-gradient(135deg, rgb(254 154 23 / 7%), rgb(227 76 76)), url(/images/p-tolak.png) center / cover no-repeat;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 250px;
  text-align: center;
  color: #fff;
  transition: transform 0.3s, box-shadow 0.3s;
/*  background: linear-gradient(135deg, #ea1e1e, #e15252);*/
}

.card1:nth-child(3) {
  background: linear-gradient(135deg, rgb(254 154 23 / 7%), rgb(227 76 76)), url(/images/p-tolak.png) center / cover no-repeat;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 250px;
  text-align: center;
  color: #fff;
  transition: transform 0.3s, box-shadow 0.3s;
/*  background: linear-gradient(135deg, #ea1e1e, #e15252);*/
}

</style>
